import React, { useEffect } from "react";

// My NFTs
const MyNFTs = ({
  walletConnected,
  myNFTs,
  fetchMyNFTs,
  revealNFT,
  reveal,
}) => {
  // Check if the wallet is connected
  useEffect(() => {
    if (!walletConnected) {
      window.location.replace("/");
    } else {
      fetchMyNFTs();
    }
  }, []);

  return (
    <React.Fragment>
      <main className="my-nfts-page">
        <section className="hero">
          <div className="container">
            <h1>
              <span>\\</span> My NFTs <span>//</span>
            </h1>

            <div className="nfts">
              {myNFTs.map((nft) => {
                return (
                  <div
                    key={nft.edition}
                    className={
                      revealNFT.tokenID == nft.edition && revealNFT.revealing
                        ? "nft flipping"
                        : revealNFT.tokenID == nft.edition &&
                          !revealNFT.revealing &&
                          revealNFT.revealed
                        ? "nft flipped"
                        : nft.revealed
                        ? "nft flipped"
                        : "nft"
                    }
                    onClick={() => {
                      if (
                        (revealNFT.tokenID == nft.edition &&
                          !revealNFT.revealing &&
                          revealNFT.revealed) ||
                        nft.revealed
                      ) {
                      } else {
                        reveal(nft.edition);
                      }
                    }}
                  >
                    <div className="inner">
                      <img
                        src={
                          nft.revealed
                            ? `https://mtv-art.mypinata.cloud/ipfs/${nft.image.replace(
                                "ipfs://",
                                ""
                              )}`
                            : "../../collection/placeholder.gif"
                        }
                        alt=""
                      />
                      <h3>{nft.revealed ? nft.name : "MaxForm #???"}</h3>
                    </div>

                    <div className="back">
                      <img
                        src={`https://mtv-art.mypinata.cloud/ipfs/${nft.image.replace(
                          "ipfs://",
                          ""
                        )}`}
                        alt=""
                      />
                      <h3>{nft.name}</h3>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        <img
          src="../../images/body-bg-img-2.png"
          alt=""
          className="body-bg-img-1"
        />
      </main>
    </React.Fragment>
  );
};

// Export
export default MyNFTs;
